import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useTheme } from "../../../context/ThemeContext";

const CategoryPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [sp] = useSearchParams();
  const { theme } = useTheme();

  // Burada slug'a göre ürünleri çağıracaksın (örn. /Urun/listeleByKategoriSlug)
  // useEffect(() => { fetchProductsBySlug(slug) }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-normal " style={{ color: theme?.textPrimary }}>
        Kategori: {slug}
      </h1>
      <p className="mt-2 text-sm" style={{ color: theme?.textSecondary }}>
        (Burada slug'a göre ürün listesi gelecek. İsteğe bağlı filtre parametreleri: {sp.toString() || "yok"})
      </p>
    </div>
  );
};

export default CategoryPage;
